import { StarFilled, StarHalf } from '@/components/shared/star-icons';

export default function ReviewStars({
  roundedStarCount,
  requiresHalfStar,
  onClickFunction
}) {
  return (
    <div
      className="flex cursor-pointer items-center"
      onClick={(e) => onClickFunction(e)}
    >
      {[...Array(parseInt(roundedStarCount, 10)).keys()].map((_, index) => (
        <StarFilled key={index} />
      ))}
      {requiresHalfStar && <StarHalf />}
    </div>
  );
}
